import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isLocalProjectPreviewEnabled } from 'core/utils/local-project-preview';
import { environment } from 'environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { localProjectPreviewBody, localProjectPreviewErrorBody } from './local-project-preview.data';

@Injectable()
export class LocalProjectPreviewInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isLocalProjectPreviewEnabled() || request.method !== 'GET') {
      return next.handle(request);
    }

    const url = new URL(request.urlWithParams, document.baseURI);
    if (url.origin !== new URL(environment.API_URL).origin
      || (!url.pathname.startsWith('/api/project/') && url.pathname !== '/api/auth/currency-rates')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map((event) => {
        if (!(event instanceof HttpResponse) || event.status !== 200) {
          return event;
        }

        const body = localProjectPreviewBody(url.pathname, event.body, url.searchParams);
        return body === undefined ? event : event.clone({ body });
      }),
      catchError((error: unknown) => {
        if (!(error instanceof HttpErrorResponse) || (error.status !== 500 && error.status !== 0)) {
          return throwError(() => error);
        }

        const body = localProjectPreviewErrorBody(url.pathname, url.searchParams);
        return body === undefined
          ? throwError(() => error)
          : of(new HttpResponse({ body, status: 200, url: request.urlWithParams }));
      }),
    );
  }
}
